import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f91759dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmForgotPassword",
  tabindex: "-1",
  "aria-labelledby": "modalConfirmForgotPassword",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title w-100 text-center fw-bold",
    id: "deleteChat"
  }, "パスワードの再設定"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "text-center my-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "text-center fw-bold mt-3" }
const _hoisted_9 = { class: "text-center text-break break-spaces mb-4" }
const _hoisted_10 = { class: "text-center fw-bold mt-3" }
const _hoisted_11 = { class: "text-center text-break break-spaces mb-4" }
const _hoisted_12 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_13 = { class: "d-flex justify-content-center button-group" }

import { onMounted, ref } from 'vue'
import { translate } from '@/languages/i18n'
import { Modal } from 'bootstrap'
import Button from '@/components/button/index.vue'

type ModalEvent = 'show' | 'hide'


export default /*#__PURE__*/_defineComponent({
  props: {
  email: String,
  name: String,
},
  emits: ['onSubmit'],
  setup(__props, { expose, emit }) {

const props = __props

const modalConfirm = ref()
const loadingButton = ref(false)



expose({
  toogleConfirmModal: (event: ModalEvent): void => {
    if (modalConfirm.value && typeof modalConfirm.value[event] === 'function') {
      modalConfirm.value[event]()
    }
    if (event === 'hide') loadingButton.value = false
  },
})

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirmForgotPassword'))
})

const onSubmit = () => {
  loadingButton.value = true
  emit('onSubmit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(translate)('SE45description1')), 1),
              _hoisted_7,
              _createTextVNode(_toDisplayString(_unref(translate)('CA50description2')), 1)
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(translate)('CA50ModalConfirmNameLabel')), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(props.name), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(translate)('email')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(props.email), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(Button, {
                  dataBsToggle: 'modal',
                  title: _unref(translate)('titleButtonEdit'),
                  type: 'secondary',
                  className: 'me-2',
                  dataBsTarget: '#editEmailUser'
                }, null, 8, ["title"]),
                _createVNode(Button, {
                  type: 'secondary',
                  title: _unref(translate)('SE40sendConfirmEmail'),
                  onClick: onSubmit,
                  disabled: loadingButton.value,
                  loading: loadingButton.value
                }, null, 8, ["title", "disabled", "loading"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})